module.exports = __webpack_public_path__ + "static/media/squared.6f437ee2.jpg";